(() => {
  'use strict';
  const clone = value => JSON.parse(JSON.stringify(value));
  const fail = () => { throw new Error('printer_data_invalid'); };
  function printer(value) {
    if (!value || !/^gid:\/\/shopify\/Collection\/[1-9]\d*$/.test(value.id) || typeof value.handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,254}$/.test(value.handle) || typeof value.name !== 'string' || !value.name.trim() || value.name.length > 250) return fail();
    return { id: value.id, handle: value.handle, name: value.name.trim() };
  }
  function normalise(value) {
    if (value == null) return { version: 1, printers: [] };
    if (typeof value === 'string') { try { value = JSON.parse(value); } catch { return fail(); } }
    if (value.version !== 1 || !Array.isArray(value.printers) || value.printers.length > 250) return fail();
    const seen = new Set(), printers = [];
    for (const raw of value.printers) { const row = printer(raw); if (!seen.has(row.id)) { seen.add(row.id); printers.push(row); } }
    return { ...clone(value), version: 1, printers };
  }
  function apply(value, action) {
    const data = normalise(value);
    if (action.type === 'add') {
      const row = printer(action.printer), index = data.printers.findIndex(p => p.id === row.id);
      if (index === -1) { if (data.printers.length >= 250) throw new Error('printer_limit'); data.printers.push(row); }
      else data.printers[index] = row;
    } else if (action.type === 'remove') {
      if (!/^gid:\/\/shopify\/Collection\/[1-9]\d*$/.test(action.id)) return fail();
      data.printers = data.printers.filter(p => p.id !== action.id);
    } else if (action.type === 'popup_seen') {
      if (!/^[A-Za-z0-9_-]{43}$/.test(action.sessionKey)) return fail();
      const keys = Array.isArray(data.ui?.popupSessions) ? data.ui.popupSessions.filter(key => typeof key === 'string') : [];
      data.ui = { ...data.ui, popupSessions: [...new Set([...keys, action.sessionKey])].slice(-8) };
    } else return fail();
    return data;
  }
  globalThis.UCWPrinterModel = Object.freeze({ clone, normalise, apply, printer });
})();

